"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Component = _interopRequireDefault(require("./Component"));

var _Button = _interopRequireDefault(require("./Button"));

var _SegmentedButton = _interopRequireDefault(require("./SegmentedButton"));

var _utils = require("../../utils");

var _globals = require("../../globals");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

/**
 * A `ButtonGroup` is a component that triggers an event when clicked and supports a toggleable
 * selected state.
 *
 * @export
 * @class ButtonGroup
 * @extends {Component<T, S>}
 * @template T
 * @template S
 */
var ButtonGroup =
/** @class */
function (_super) {
  __extends(ButtonGroup, _super);
  /**
   * Initializes and returns a button group instance with the specified configuration options.
   *
   * @param {*} [opts]
   * @memberof ButtonGroup
   */


  function ButtonGroup(opts) {
    var _this = this;

    opts = opts || {};
    opts = (0, _utils.extend)({
      defaultType: 'data-item',
      multiselect: true
    }, opts, {
      className: opts.className ? "ui-btn-group " + opts.className : 'ui-btn-group',
      ui: {
        label: "." + _globals.Globals.cssPrefix + "ui-btn-group-label",
        buttons: "." + _globals.Globals.cssPrefix + "ui-btn-group-items"
      }
    });
    _this = _super.call(this, opts) || this;
    _this._buttons = [];

    _this.setState({
      expanded: true
    });

    return _this;
  }

  Object.defineProperty(ButtonGroup.prototype, "buttons", {
    /**
     * Array of button elements included in the group.
     *
     * @readonly
     * @type {IToggleable[]}
     * @memberof ButtonGroup
     */
    get: function () {
      return this._buttons;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns the button from the group associated with the specified identifier, if any.
   *
   * @param {string} id
   * @returns {IToggleable}
   * @memberof ButtonGroup
   */

  ButtonGroup.prototype.buttonForId = function (id) {
    var result;
    this.buttons.forEach(function (button, index) {
      if (button.id === id && !(0, _utils.isset)(result)) {
        result = button;
      }
    });
    return result;
  };
  /**
   * Returns the button from the group associated with the specified value, if any.
   *
   * @param {string} value
   * @returns {IToggleable}
   * @memberof ButtonGroup
   */


  ButtonGroup.prototype.buttonForValue = function (value) {
    var result;
    this.buttons.forEach(function (button, index) {
      if (button.value === value && !(0, _utils.isset)(result)) {
        result = button;
      }
    });
    return result;
  };

  ButtonGroup.prototype.size = function () {
    var size = _super.prototype.size.call(this);

    var h = 0;

    if (this.ui.label) {
      h += this.ui.label.outerHeight(true);
    }

    this.buttons.forEach(function (button) {
      h += button.size().height;
    });
    var pad = this.$el.padding();
    var borders = this.$el.borders();
    h += pad.top + pad.bottom;
    h += borders.top + borders.bottom;
    size.height = h;
    return size;
  };

  ButtonGroup.prototype._render = function (data) {
    var title = !(0, _utils.isEmpty)(this.opts.title) ? "<div class=\"" + _globals.Globals.cssPrefix + "ui-btn-group-label\">" + this.opts.title + "</div>" : '';
    return "\n\t\t\t<div class=\"awxjs__ui-btn-group\">\n\t\t\t\t" + title + "\n\t\t\t\t<div class=\"" + _globals.Globals.cssPrefix + "ui-btn-group-items\" data-multiselect=\"" + (this.opts.multiselect ? 1 : 0) + "\"></div>\n\t\t\t</div>\n\t\t";
  };

  ButtonGroup.prototype._onAddedToDOM = function () {
    var _this = this;

    _super.prototype._onAddedToDOM.call(this);

    if (this.opts.buttons) {
      this._buttons = (this.opts.buttons || []).map(function (opts) {
        opts.options = __assign(__assign({}, _this.opts.options), opts.options); // allow each button to inherit parent controls

        if (_this.opts.controls && !(0, _utils.isset)(opts.controls)) {
          opts.controls = (0, _utils.extend)({}, _this.opts.controls);
        }

        if (opts.segments) {
          return new _SegmentedButton.default(opts);
        }

        var buttonType = opts.type || _this.opts.defaultType;
        return new _Button.default(opts);
      });
    }

    if (this.ui.buttons && this.ui.buttons.children().length === 0) {
      this.buttons.forEach(function (button) {
        button.addTo(_this.ui.buttons);
      });
    }
  };

  ButtonGroup.prototype._setupEvents = function () {
    var _this = this;

    _super.prototype._setupEvents.call(this);

    this.buttons.forEach(function (button) {
      if (button instanceof _SegmentedButton.default) {
        button.on('expanded collapsed', function (e) {
          _this.trigger('change:size', e.data);
        });
      }
    });

    if (this.opts.multiselect === false) {
      this.buttons.forEach(function (button) {
        if (button.selected) {
          button.disable(true);
          _this._selectedButton = button;
        }

        button.on('select', function () {
          if (_this._selectedButton) {
            _this._selectedButton.deselect();

            _this._selectedButton.disable(false);
          }

          _this._selectedButton = button;
          button.disable(true);

          if ((0, _utils.isFunction)(_this.opts.onChange)) {
            _this.opts.onChange(button.value);
          }

          _this.trigger('change', {
            value: button.value
          });
        });
      });
    }
  };
  /**
   * Events that can be triggered by a `ButtonGroup` instance.
   *
   * @static
   * @memberof ButtonGroup
   */


  ButtonGroup.Event = {
    /** Fired when the button group is expanded. */
    EXPAND: 'expand',

    /** Fired when the button group is collapsed. */
    COLLAPSE: 'collapse'
  };
  return ButtonGroup;
}(_Component.default);

var _default = ButtonGroup;
exports.default = _default;
module.exports = exports.default;